import { camelCase } from 'lodash';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Checkbox, Icon, IconButton, TableCell, TableRow, TextField } from '@material-ui/core';
import { DragIndicator } from '@material-ui/icons';
import { useTimeout } from '@sierralabs/core-ui';
import EntityDataTypePicker from '../pickers/EntityDataTypePicker';
import { useEntityContext } from '../EntityContext';
const StyledTableRow = styled(TableRow) `
  overflow: auto;
  vertical-align: top;
  .MuiTableCell-root {
    padding: 12px 8px 4px 8px;
  }
  .column-type {
    min-width: 180px;
  }
  &.dragging {
    opacity: 0.8;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  }
  .delete-cell {
    padding-top: 18px;
  }
  .drag-cell {
    width: 40px;
  }
  .drag-handle {
    margin-top: 6px;
    cursor: grab;
    opacity: 0.25;
    transition: opacity 300ms;
    &:hover {
      opacity: 1;
    }
    svg {
      color: #bbb;
    }
  }
`;
export const EntityFieldListRow = props => {
    var _a, _b, _c, _d;
    const { index, isDragging, column: initialColumn, entity, disabled, className, tableRowProps, dragHandleProps, onDeleteClick } = props;
    const [debounceUpdate] = useTimeout();
    const { trackChanges, validationError } = useEntityContext();
    const [column, setColumn] = useState(initialColumn);
    const error = validationError.columns[index];
    const classes = [className];
    isDragging && classes.push('dragging');
    const updateColumn = (updated) => {
        for (const [k, value] of Object.entries(updated)) {
            const key = k;
            if (initialColumn[key] !== value) {
                trackChanges.update(`columns[${index}].${key}`, value);
            }
        }
    };
    const update = (updated, replace = false) => {
        setColumn(column => {
            const newColumn = replace
                ? updated
                : Object.assign(Object.assign({}, column), updated);
            debounceUpdate(() => updateColumn(newColumn), 300);
            return newColumn;
        });
    };
    useEffect(() => {
        setColumn(initialColumn);
    }, [initialColumn]);
    return (React.createElement(StyledTableRow, Object.assign({}, tableRowProps, { className: classes.join(' ') }),
        React.createElement(TableCell, Object.assign({}, dragHandleProps, { align: 'center', className: 'drag-cell' }),
            React.createElement(DragIndicator, { className: 'drag-handle' })),
        React.createElement(TableCell, null,
            React.createElement(TextField, { fullWidth: true, size: 'small', variant: 'outlined', disabled: disabled, placeholder: 'Field Name', value: column.displayName, inputProps: { maxLength: 24 }, error: Boolean((_a = error === null || error === void 0 ? void 0 : error.displayName) === null || _a === void 0 ? void 0 : _a.message), helperText: ((_b = error === null || error === void 0 ? void 0 : error.displayName) === null || _b === void 0 ? void 0 : _b.message) ||
                    `Property Key: ${camelCase(column.displayName)}`, onChange: event => update({ displayName: event.target.value }) })),
        React.createElement(TableCell, { className: 'column-type' },
            React.createElement(EntityDataTypePicker, { index: index, column: column, entity: entity, disabled: disabled, error: Boolean((_c = error === null || error === void 0 ? void 0 : error.type) === null || _c === void 0 ? void 0 : _c.message), helperText: (_d = error === null || error === void 0 ? void 0 : error.type) === null || _d === void 0 ? void 0 : _d.message, onChange: columnSchema => update(columnSchema, true) })),
        React.createElement(TableCell, { className: 'column-array' },
            React.createElement(Checkbox, { size: 'small', color: 'primary', disabled: disabled, checked: Boolean(column.array), onChange: event => update({ array: event.target.checked }) })),
        React.createElement(TableCell, { className: 'comment input-column' },
            React.createElement(TextField, { fullWidth: true, size: 'small', variant: 'outlined', autoComplete: 'off', disabled: disabled, placeholder: 'Add a description.', value: column.comment || '', onChange: event => update({ comment: event.target.value }) })),
        React.createElement(TableCell, { className: 'delete-cell' },
            React.createElement(IconButton, { size: 'small', disabled: disabled, onClick: () => {
                    if (onDeleteClick) {
                        onDeleteClick();
                        return;
                    }
                    trackChanges.delete(`columns[${index}]`);
                } },
                React.createElement(Icon, null, "delete_outlined")))));
};
export default EntityFieldListRow;
export const SortableEntityFieldListRow = props => {
    const { columnId, isDragging } = props;
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: columnId });
    return (React.createElement(EntityFieldListRow, Object.assign({}, props, { dragHandleProps: Object.assign(Object.assign({}, attributes), listeners), tableRowProps: {
            ref: setNodeRef,
            style: {
                opacity: isDragging ? 0.75 : undefined,
                transform: CSS.Translate.toString(transform),
                transition: transition || undefined
            }
        } })));
};
//# sourceMappingURL=EntityFieldListRow.js.map